import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { Data2Service } from '../../../common/data2.service';

@Component({
	selector: 'app-locations-list-filters',
	templateUrl: './locations-list-filters.component.html',
	styleUrls: ['./locations-list-filters.component.css'],
})
export class LocationsListFiltersComponent extends FiltersComponent {
	filters = {
		limit: null,
		offset: null,
		search: '',
	};
	@Input() limit: Array<any> = [];
	@Input() offset: Array<any> = [];
	@Input() search: Array<any> = [];
}
